var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.estate.estate_parent ||
    _vm.estate.estates_child ||
    _vm.estate.estates_sibling
    ? _c("div", { staticClass: "estate-container" }, [
        _c(
          "div",
          { staticClass: "estate-family-title" },
          [
            _c("masked-image", {
              staticClass: "icon_title",
              attrs: { src: "/img/icons/industrial.svg" }
            }),
            _vm._v(" "),
            _c("h2", [
              _vm.estate.estate_parent
                ? _c("div", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.lang.related.estate_parent) +
                        "\n            "
                    )
                  ])
                : _vm.estate.estates_child || _vm.estate.estates_sibling
                ? _c("div", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.lang.related.estates_child) +
                        "\n            "
                    )
                  ])
                : _vm._e()
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "estate-family" },
          [
            _vm.estate.estate_parent ||
            _vm.estate.estate_parent ||
            _vm.estate.estates_child
              ? [
                  _c(
                    "my-carousel",
                    {
                      attrs: {
                        "per-page-custom": [
                          [0, 1],
                          [768, 2],
                          [940, 3]
                        ],
                        "scroll-per-page": true,
                        "navigation-enabled": true,
                        "navigation-next-label": "<span></span>",
                        "navigation-prev-label": "<span></span>",
                        "pagination-enabled": true
                      }
                    },
                    [
                      _vm.estate.estate_parent
                        ? _c(
                            "slide",
                            [
                              _c("related-estate", {
                                attrs: {
                                  related_estate: _vm.estate.estate_parent,
                                  type: "parent"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.estate.estates_sibling, function(
                        estate_sibling,
                        num_sibling
                      ) {
                        return _vm.estate.estates_sibling
                          ? _c(
                              "slide",
                              { key: num_sibling },
                              [
                                _c("related-estate", {
                                  attrs: {
                                    related_estate: estate_sibling,
                                    type: "sibling"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.estate.estates_child, function(
                        estate_child,
                        num_child
                      ) {
                        return _vm.estate.estates_child
                          ? _c(
                              "slide",
                              { key: num_child },
                              [
                                _c("related-estate", {
                                  attrs: {
                                    related_estate: estate_child,
                                    type: "child"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      })
                    ],
                    2
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }